import { component } from 'picoapp'
import choozy from 'choozy'
import { on } from 'martha'
import dcx from 'dcx'

export default component((node, ctx) => {
  const { select, text } = choozy(node)

  setTimeout(render, 100)

  on(select, 'change', () => {
    render()
  })

  function render() {
    text.textContent = select.value
  }
})
